import MaintenanceBlanksTable from './components/MaintenanceBlanksTable'
import { useRecoilValue } from 'recoil'
import maintenanceBlankSchemasAtom from './maintenanceBlankSchemas.atom.ts'
import BadgeCount from '../../../../shared/Badges/BadgeCount'
import Button from '../../../../shared/Buttons/Button'
import PlusIcon from '../../../../assets/icons/plus.svg?react'
import { useState } from 'react'
import CreateBlankSidePage from './components/CreateBlankSidePage'
import ProtectedContent from '@/services/rights/ProtectedContent'

const MaintenanceBlanks = () => {
  const [createPageOpen, setCreatePageOpen] = useState(false)
  const blankSchemas = useRecoilValue(maintenanceBlankSchemasAtom).items

  return (
    <>
      <div className="inline-flex-gap gap24 center">
        <div className="inline-flex-gap gap8 center">
          <h2 className="text-heading-4">Бланки ТО</h2>
          <BadgeCount type="default" count={blankSchemas.length} />
        </div>
        <ProtectedContent
          requiredRight="mdm:create_schema"
          fallBack={
            <span className="text-nm text-description">
              Для добавления нового бланка обратитесь к администратору системы
            </span>
          }
        >
          <Button
            size="default"
            type="primary"
            text="Создать бланк"
            icon={<PlusIcon className="text-white" />}
            onClick={() => setCreatePageOpen(true)}
          />
        </ProtectedContent>
      </div>
      <MaintenanceBlanksTable />
      <CreateBlankSidePage onClose={() => setCreatePageOpen(false)} open={createPageOpen} />
    </>
  )
}

export default MaintenanceBlanks
